export const FM_CONFIGURATION_OPTION_KEY = 'FM_CONFIGURATION_OPTIONS';

export const FM_CONFIGURATION_OPTION_VALUES = {
  PUBLIC_HOLIDAYS_VIEW_DISABLED: 'PUBLIC_HOLIDAYS_VIEW_DISABLED',
  PUBLIC_HOLIDAYS_VIEW_ENABLED: 'PUBLIC_HOLIDAYS_VIEW_ENABLED',
} as const;
